<template>
  <div :class="['goal-activity-list-header']">
    <document-list-header
      :slots="slots"
      :allowed-view-types="allowedViewTypes"
      :filter-props="filterProps"
      :show-create-view="showCreateView"
      :show-views-selector="showViewsSelector"
      :sort-options="sortOptions"
      :multi-model="multiModel"
      :data-loading="dataLoading"
      show-saved-view-info
      has-dynamic-date-filters
    />
  </div>
</template>

<script>
import DocumentListHeader from '@/components/list/DocumentListHeader.vue';
import useGoalActivitySorting from '@/composables/goal-activity/sort';
import useUsers from '@/composables/user/users';
import { SLOTS, VIEWS_SERVICE } from '@/lib/constants';
import { inject } from 'vue';
import { viewType } from 'shared/constants.json';

export default {
  name: 'GoalActivityListHeader',
  props: {
    showViewsSelector: {
      type: Boolean,
      default: false,
    },
    showCreateView: {
      type: Boolean,
      default: false,
    },
    filterProps: {
      type: Array,
      required: true,
    },
    allowedViewTypes: {
      type: Array,
      default: () => [
        viewType.feed,
        viewType.list,
      ],
    },
    multiModel: {
      type: Boolean,
      default: false,
    },
    slots: {
      type: Array,
      default: () => [],
      validator(slots) {
        return slots.every((slot) => [SLOTS.FILTER, SLOTS.SORTER].includes(slot.name));
      },
    },
    dataLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: { DocumentListHeader },
  setup() {
    const userSvc = useUsers();
    const { sortOptions } = useGoalActivitySorting(userSvc);
    const viewSvc = inject(VIEWS_SERVICE);
    return {
      sortOptions,
      currentView: viewSvc.currentView,
    };
  },
};
</script>

<style scoped lang="scss" type="text/scss">
</style>
